<template>
  <tr>
    <td class="type">
      <img v-if="integrationType" :src="integrationType.image" />
    </td>
    <td>
      <app-toggle :value="isActive" @input="toggleStatus"></app-toggle>
    </td>
    <td class="name">
      {{ item.name }}
    </td>
    <td>
      {{ creationDate }}
    </td>
    <td class="icons">
      <IntegrationModal
        :integration="integration"
        @set-integration="setIntegration"
      >
        <i
          v-tooltip="$t('message.generics.message.edit')"
          class="mdi mdi-settings pointer"
          @click="edit"
        ></i>
      </IntegrationModal>

      <i
        v-if="item.allowWriteClientData"
        v-tooltip="$t('message.generics.message.test')"
        class="mdi mdi-call-made pointer"
        @click="test"
      ></i>

      <IntegrationTestModal v-if="item.allowGetClientData" :integration="item">
        <i
          v-tooltip="$t('message.integrations.message.testExternalBaseAccess')"
          class="mdi mdi-check-network-outline"
        ></i>
      </IntegrationTestModal>

      <button
        v-if="hasFailAttempts"
        @click="openIntegrationFailedAttemptsModal"
      >
        <i
          v-tooltip="$t('message.integrations.message.recordsNotSent')"
          class="mdi mdi-alert-circle-outline"
          slot="activator"
        ></i>
      </button>

      <v-icon
        size="20"
        slot="activator"
        v-tooltip="$t('message.generics.message.remove')"
        @click="showRemoveModal"
        >mdi-delete</v-icon
      >
    </td>

    <IntegrationFailedAttemptsModal
      v-if="hasFailAttempts && isIntegrationFailedAttemptsModalOpen"
      v-model="isIntegrationFailedAttemptsModalOpen"
      :integration="dataItem"
      @reload="emitReload"
    />

    <app-confirmation-modal
      :value="!!showDeleteModal"
      :confirm-label="$t('message.generics.message.remove')"
      @confirm="confirmRemove"
      @cancel="showDeleteModal = false"
    >
      <span slot="heading">
        {{ $t("message.integrations.message.removeIntegration") }}
      </span>
      <span>
        {{ $t("message.integrations.message.removeIntegrationConfirmation") }}
      </span>
    </app-confirmation-modal>
  </tr>
</template>

<script>
import AppToggle from "@components/Toggle";
import IntegrationModal from "./integration-modal/IntegrationModal";
import IntegrationFailedAttemptsModal from "./integration-failed-attempts-modal/IntegrationFailedAttemptsModal.vue";
import IntegrationTestModal from "./integration-test-modal/IntegrationTestModal.vue";
import moment from "moment";
import AppConfirmationModal from "@components/ConfirmationModal";
import EventBus from "@packages/event-bus";

export default {
  components: {
    AppConfirmationModal,
    IntegrationModal,
    IntegrationFailedAttemptsModal,
    AppToggle,
    IntegrationTestModal,
  },

  props: {
    dataItem: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      showDeleteModal: false,
      integration: undefined,
      typeOptions: [],
      isIntegrationFailedAttemptsModalOpen: false,
    };
  },

  computed: {
    item() {
      return this.dataItem;
    },
    creationDate() {
      return moment(this.item.creationDate).format("L");
    },
    isActive() {
      return this.item.isActive;
    },
    hasFailAttempts() {
      return !!this.item && !!this.item.failAttempts;
    },
    integrationType() {
      return this.typeOptions.find((type) => {
        return this.item.appType === type.value;
      });
    },
  },

  async mounted() {
    const types = await this.$api.integrationManagement.types();

    const typeOptions = Object.keys(types).map((typeKey) => {
      return {
        value: typeKey,
        text: types[typeKey].label,
        image: types[typeKey].image,
      };
    });

    this.typeOptions = typeOptions;
  },

  methods: {
    async toggleStatus() {
      try {
        const res = await this.$api.integrationManagement.toggleStatus({
          id: this.item.id,
        });

        this.dataItem.isActive = res;

        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: res
            ? this.$t("message.successMessages.message.integrationActivated")
            : this.$t("message.successMessages.message.integrationDisabled"),
        });
      } catch (error) {
        console.log(error);
      }
    },
    setIntegration(integration) {
      this.integration = integration;
    },
    showRemoveModal() {
      this.showDeleteModal = true;
    },
    async confirmRemove() {
      try {
        EventBus.$emit("SHOW_SPINNER");
        await this.$api.integrationManagement.remove({ id: this.item.id });
        this.showDeleteModal = false;
        EventBus.$emit("LOAD_INTEGRATION");
      } catch (error) {
        console.log(error);
      } finally {
        EventBus.$emit("CANCEL_SPINNER");
      }
    },
    async edit() {
      let integration = await this.$api.integrationManagement.get(this.item.id);
      this.integration = integration;
    },

    report() {
      EventBus.$emit(
        "RESET_INTEGRATION_REPORT_MODAL",
        JSON.parse(JSON.stringify(this.item))
      );
    },
    async test() {
      try {
        let message = await this.$api.integrationManagement.testSend({
          _id: this.dataItem.id,
        });
        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: message.message,
          timeout: 3000,
        });
      } catch {
        //leave empty
      } finally {
        this.emitReload();
      }
    },
    emitReload() {
      this.$emit("reload");
    },
    openIntegrationFailedAttemptsModal() {
      this.isIntegrationFailedAttemptsModalOpen = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.icons {
  display: flex;
  align-items: center;
  .mdi {
    font-size: 18px;
  }
}

.name {
  display: flex;
  align-items: center;
}

.type {
  img {
    width: 30px;
    height: 30px;
  }
}

.icon-green {
  color: $primary;
}
</style>
